import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from './utils';
import sizes from 'styles/sizes';
import {
  FooterNavigationCatTitle,
  FooterNavigationCat,
  FooterNavigationCatLinks,
  FooterNavigationCatCarrot,
  Caret,
} from './styles';

const FooterTab = ({ data }) => {
  const [showList, setShowList] = useState(true);
  const size = useWindowSize();
  const toggleList = () => {
    setShowList(!showList);
  };
  let debonceSetShowList;

  useEffect(() => {
    handleWidthScreen();
  }, [size.width]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWidthScreen = () => {
    clearInterval(debonceSetShowList);

    debonceSetShowList = setTimeout(() => {
      if (size.width <= sizes.media.smallMaxWidth) {
        return setShowList(false);
      }

      return setShowList(true);
    }, 250);
  }

  return (
    <FooterNavigationCat>
      {size.width <= sizes.media.smallMaxWidth && (
        <button onClick={toggleList}></button>
      )}
      <label>
        <FooterNavigationCatTitle>{data.label}</FooterNavigationCatTitle>
        <FooterNavigationCatCarrot>
          {showList ? <Caret left /> : <Caret right />}
        </FooterNavigationCatCarrot>
      </label>
      {showList && (
        <FooterNavigationCatLinks>
          {data.children.map(e => (
            <li key={e.label}>
              <a href={e.path}>{e.label}</a>
            </li>
          ))}
        </FooterNavigationCatLinks>
      )}
    </FooterNavigationCat>
  );
};

FooterTab.propTypes = {
  data: PropTypes.object,
};

export default FooterTab;
